export default __webpack_public_path__ + "static/product1-95cd42364cac4239dc7284f7921b8766.jpg";